const MAP = {
  booked: { label: "Booked", cls: "bg-primary/15 text-primary border-primary/30" },
  consulting: { label: "In consultation", cls: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  completed: { label: "Completed", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  cancelled: { label: "Cancelled", cls: "bg-rose-500/15 text-rose-300 border-rose-500/30" },
  rescheduled: { label: "Rescheduled", cls: "bg-teal-500/15 text-teal-300 border-teal-500/30" },
  Ready: { label: "Ready", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
};

export default function StatusBadge({ status, className = "" }) {
  const m = MAP[status] || { label: status, cls: "bg-muted text-muted-foreground border-border/40" };
  return (
    <span data-testid="status-badge"
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold ${m.cls} ${className}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {m.label}
    </span>
  );
}
